if (!customElements.get('price-chart-component')) {
  customElements.define(
    'price-chart-component',
    class PriceChartComponent extends HTMLElement {
      constructor() {
        super();
        this.showModalPrice = document.querySelector('.link-view-more');
        this.hideModalPrice = this.querySelector('.back-hide-modal');
        let that = this;
        if (this.hideModalPrice) {
          this.hideModalPrice.addEventListener('click', (e) => {
            e.preventDefault();
            let modalPrices = document.querySelector('.price-chart-component'),
              sectionMainProduct = document.querySelector('.container-panel'),
              nav = document.querySelector('.section-main-products > .product-navigator-component '),
              featureProducts = document.querySelector('.featured-product'),
              requestsComponent = document.querySelector('.requests-panel-component');

            // Hide Section
            modalPrices ? that.styleDisplay(modalPrices, 'none') : '';

            //Show Sections
            sectionMainProduct ? that.styleDisplay(sectionMainProduct, 'flex') : '';
            nav ? that.styleDisplay(nav, 'flex') : '';
            featureProducts ? that.styleDisplay(featureProducts, 'flex') : '';
            requestsComponent ? that.styleDisplay(requestsComponent, 'flex') : '';
          });
        }

        if (this.showModalPrice) {
          this.showModalPrice.addEventListener('click', (e) => {
            e.preventDefault();

            const url = `${window.location.href}&section_id=main-product`;
            fetch(url)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                let modal = html.querySelector('.price-chart-component');
                let modalPrices = document.querySelector('.price-chart-component');
                modalPrices.innerHTML = modal.innerHTML;
                let sectionMainProduct = document.querySelector('.container-panel'),
                  nav = document.querySelector('.section-main-products > .product-navigator-component '),
                  featureProducts = document.querySelector('.featured-product'),
                  requestsComponent = document.querySelector('.requests-panel-component');

                // Show Section
                modalPrices ? that.styleDisplay(modalPrices, 'block') : '';

                //Hide Sections
                sectionMainProduct ? that.styleDisplay(sectionMainProduct, 'none') : '';
                nav ? that.styleDisplay(nav, 'none') : '';
                featureProducts ? that.styleDisplay(featureProducts, 'none') : '';
                requestsComponent ? that.styleDisplay(requestsComponent, 'none') : '';
              });
          });
        }
      }
      styleDisplay(element, style) {
        element.style.display = style;
      }
    },
  );
}
